import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { App, Button, DatePicker, Form, Input, } from 'antd';
import FormModal from 'components/FormModal';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import dayjs from 'dayjs';
import { updateProjectDescription } from 'screens/DashboardScreen/pages/EditorPage/update-project-description';
import styles from './style.module.less';
const { TextArea } = Input;
const ProjectMetadataModal = ({ visible, onCancel, onMetadataChange, enqueueProjectUpdate, description, projectId, }) => {
    var _a, _b, _c;
    const { session } = useSession();
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const notes = Form.useWatch('notes', form);
    const author = Form.useWatch('author', form);
    const start = (_a = Form.useWatch('start', form)) !== null && _a !== void 0 ? _a : null;
    const saveMetadata = async () => {
        await updateProjectDescription({
            connection: session.connection,
            projectId,
            currentDescription: description,
            updates: {
                author: author !== null && author !== void 0 ? author : null,
                start: start !== null && start !== void 0 ? start : null,
                notes: notes !== null && notes !== void 0 ? notes : null,
            },
            enqueueProjectUpdate,
            message,
            onSuccess: () => {
                onMetadataChange === null || onMetadataChange === void 0 ? void 0 : onMetadataChange({ author, start, notes });
                onCancel();
            },
        });
    };
    return (_jsx(FormModal, { muteShortcuts: ['Tab', 'Shift+Tab'], className: styles.projectNotesModal, title: txt('aboutProject'), open: visible, onCancel: onCancel, footer: [
            _jsx(Button, { onClick: onCancel, children: txt('close') }, "back"),
            _jsx(Button, { type: "primary", onClick: saveMetadata, children: txt('save') }, "submit"),
        ], children: _jsxs(Form, { form: form, labelCol: { span: 8 }, initialValues: {
                author: (_b = description.author) !== null && _b !== void 0 ? _b : '',
                start: description.start === null ? null : dayjs(description.start),
                notes: (_c = description.notes) !== null && _c !== void 0 ? _c : '',
            }, children: [_jsx(Form.Item, { name: "author", label: txt('author'), children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "start", label: txt('transcriptionStart'), children: _jsx(DatePicker, { format: ['DD/MM/YYYY HH:mm:ss'], showTime: {
                            format: 'HH:mm:ss',
                        } }) }), _jsx(Form.Item, { name: "notes", label: txt('notes'), children: _jsx(TextArea, { id: "textarea-project-notes", autoSize: { minRows: 6, maxRows: 15 }, autoFocus: true }) })] }) }));
};
export default ProjectMetadataModal;
